import { getLang } from 'i18n/locale';
import { OneTrustCategories } from 'onetrust/constants';
import { useCallback, useRef } from 'react';
import { useAnalytics } from 'util/analytics';
import { useOneTrustIframe } from 'util/useAddOneTrustIframe';
import styles from './iframe.module.scss';

const MapContainer = ({
  place,
  lat,
  lng,
}: {
  place: string,
  lat: string,
  lng: string,
}) => {
  const a = useAnalytics();
  const div = useRef<HTMLDivElement>(null);

  const onClick = useCallback(() => {
    a.expandImage({ content: 'Google Map' });
  }, [a]);

  useOneTrustIframe(div?.current,
    `https://www.google.com/maps/embed/v1/view?zoom=13&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}&language=${getLang()}&center=${lat},${lng}`,
    place || '',
    OneTrustCategories.TargetingCookies,
    {
      loading: 'lazy',
      allowfullscreen: 'allowfullscreen',
    });

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/interactive-supports-focus
    <div role="button" ref={div} onClick={onClick} className={styles.iframe} />
  );
};
export default MapContainer;
